import t from "../../theme";

export const useGetPolicyViewerStyles = () => {
  return {
    frameWrapper: {
      position: "relative",
      minHeight: "78vh",
    },
    policyFrame: {
      display: "block",
      width: "100%",
      height: "100%",
      minHeight: "78vh",
      border: "none",
      opacity: 0,
      transition: "opacity 0.35s ease",
    },
    policyFrameLoaded: {
      opacity: 1,
    },
    loader: {
      position: "absolute",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      background: t.glass.heavy,
      color: t.text.muted,
      fontFamily: t.font.family,
      fontSize: "0.9rem",
      fontWeight: 600,
    },
    spinner: {
      width: "36px",
      height: "36px",
      borderRadius: t.radius.circle,
      border: `3px solid ${t.green.border}`,
      borderTopColor: t.green.solid,
      animation: "policy-spin 0.8s linear infinite",
      "@keyframes policy-spin": {
        to: { transform: "rotate(360deg)" },
      },
    },
  };
};
